import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

export const state = {
  operations: []
}

export const getters = {
  operations: state => state.operations
}

export const mutations = {
  OPERATIONS (state, data) {
    state.operations = data
  }
}

export const actions = {
  async getOperationsData ({ commit }) {
    await axios.get(laroute.route('get-operations-data', { companyAbbr: store.getters['auth/company'] }))
      .then((res) => {
        commit('OPERATIONS', res.data.data)
      })
  },

  async create ({ commit }, data) {
    await axios.post(laroute.route('create-methods'), { data })
  },

  async update ({ commit }, data) {
    await axios.patch(laroute.route('update-methods'), { data })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/productionMatrix.js